export const currentYear = () => {
    return new Date().getUTCFullYear().toString()
}